export default function () {
  const switchButtons = document.querySelectorAll('.switch:not(#switch-matomo)')

  switchButtons.forEach(button => {
    button.addEventListener('click', function () {
      const pressed = this.getAttribute('aria-pressed')

      if (pressed === 'false') {
        this.setAttribute('aria-pressed', true)
      } else {
        this.setAttribute('aria-pressed', false)
      }
    }, false)
  }, false)

  const matomoSwitch = document.querySelector('#switch-matomo')

  function getMatomoOptOut () {
    try {
      return localStorage.getItem('matomoOptOut') === 'true'
    } catch (e) {
      return false
    }
  }

  function setMatomoOptOut (value) {
    try {
      localStorage.setItem('matomoOptOut', value ? 'true' : 'false')
    } catch (e) {
    }
  }

  if (matomoSwitch) {
    const optedOut = getMatomoOptOut()

    matomoSwitch.setAttribute('aria-pressed', optedOut ? 'false' : 'true')

    matomoSwitch.addEventListener('click', function () {
      const pressed = this.getAttribute('aria-pressed') === 'true'

      const newPressed = !pressed
      this.setAttribute('aria-pressed', newPressed ? 'true' : 'false')

      setMatomoOptOut(!newPressed)

      setTimeout(() => {
        window.location.reload()
      }, 300)
    }, false)
  }
}
